import React from "react";
import { NextPage } from "next";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { Layout } from "@kursk/components/Layout/Layout";
import { placesListSlice } from "@common/redux/slices/places.slice";
import { HeaderBlock } from "@kursk/components/ui/HeaderBlock/HeaderBlock";
import { ContentBlock } from "@kursk/components/ui/ContentBlock/ContentBlock";
import { SocialLinks } from "@kursk/components/ui/SocialLinks/SocialLinks";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { ContactsBlock } from "@kursk/components/ui/ContactsBlock/ContactsBlock";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import styles from "./SingleMuseum.module.scss";
import { getAddress } from "@kursk/utils/getAddress";
import { getConfig } from "@root/config/config";
import { VirtualMuseum } from "@kursk/components/ui/VirtualMuseum/VirtualMuseum";

export const SingleMuseum: NextPage = () => {
  const { place } = useSelectSlice(placesListSlice);
  const { forPlacesEvents, forPlacesStreams, forPlacesVirtualMuseums } = useSelectSlice(recommendationSlice);

  if (!place) {
    return <></>;
  }
  return (
    <Layout key={`museum_${place._id}`}>
      <SeoMetaTitles page="singleMuseum" entity={{
        name: place.name,
        seo: place.seo,
        image: place.image,
        address: getAddress(place.address),
      }} showOgImage={true}/>
      <section className={styles.place_header}>
        <HeaderBlock
          entityType={'museums'}
          entity={place}
          goBack={'/museums'}
          goBackTitle={'вернуться к списку виртуальных музеев'}
          customBuyButton={<div/>}
          customBreadCrumb={{
            title: null,
            link: null,
          }}
        />
      </section>
      <section className={styles.place_socialLinks}>
        <SocialLinks/>
      </section>
      <section className={styles.place_content}>
        <ContentBlock content={place.content} source={place?.source}/>
      </section>
      {place?.virtualMuseum && <section className={styles.place_virtual}>
        <VirtualMuseum place={place}/>
      </section>}
      <section>
        <ContactsBlock entity={place}/>
      </section>
      <section className={styles.place_recommendations}>
        <RecommendationsBlock
          entityType="events"
          data={forPlacesEvents}
          title={'события в этом месте'}
          goTo={'/events'}
          goToTitle={'все события'}/>
      </section>
      <section className={styles.place_recommendations}>
        <RecommendationsBlock
          entityType="streams"
          data={forPlacesStreams}
          title={'трансляции в этом месте'}
          goTo={'/streams'}
          goToTitle={'все трансляции'}
          newTab={getConfig().liveRedirect.enabled}
        />
      </section>
      <section className={styles.place_recommendations}>
        <RecommendationsBlock
          entityType="museums"
          data={forPlacesVirtualMuseums}
          title={'также рекомендуем'}
          goTo={'/museums'}
          goToTitle={'все виртуальные музеи'}/>
      </section>
      <section className={styles.place_socials}>
        <Socials/>
      </section>
    </Layout>
  )
}
